// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"dde3463e4575a2d1","9983":"b2715e22e263f5e6"}[chunkId] + ".css";
};